const sortingOptions = [
  { label: 'Popularity', value: 'popularity', trackName: 'Popularity' },
  { label: 'Name (A-Z)', value: 'asc', trackName: 'A-Z' },
  { label: 'Name (Z-A)', value: 'desc', trackName: 'Z-A' },
];

const minimumBetChips = [
  {
    label: 'Less than £0,10',
    value: 'less-than-0-10',
  },
  {
    label: '£0,10 - £0,50',
    value: '0-10-50',
  },
  {
    label: '£0,50 - £1',
    value: '50-1',
  },
  {
    label: '£1 - £2',
    value: '1-2',
  },
  {
    label: 'More than £2',
    value: 'more-than-2',
  },
];

const staticGameFilters = {
  sortingOptions,
  minimumBetChips,
};

export { staticGameFilters };
